import React from 'react'
// import Customer_header from './Customer_header'
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { Container, Row, Col, Form, Button, ProgressBar, ModalHeader, ModalTitle } from "react-bootstrap";
// import './customer_style.css';
import Modal from 'react-bootstrap/Modal';
// import Footer from './Footer'
// import { Tooltip as ReactTooltip } from "react-tooltip";
import axios from "axios";
import Swal from 'sweetalert2'
import { useLocation } from 'react-router-dom';
import ReactLoading from 'react-loading';
// import config from "../config"
import exportValue from '../../apiconfig'
import Moment from 'react-moment';
// import Header_nav from './Header_nav';
import download from 'downloadjs'
import Sub_header from '../Sub_header';
import Left_panel from '../Left_panel';

const My_orders = () => {
    let navigate = useNavigate()
    let detail = {};

if (localStorage.getItem('admin_login')) {
  detail = JSON.parse(localStorage.getItem('admin_login'));
}
console.log("detail ==" , detail)
    const [customeroption, setCustomerOption] = React.useState([]);
    const[customers , setCustomers] = React.useState([]);

    const [selectedOption1, setSelectedOption1] = React.useState(null);
    const[recordid,setRecordid] = React.useState({record_id:""})
    const [uploadModalState, setUploadModalState] = React.useState({ show: false,excel_fle:"" ,customer_id:"" });
    const[dimensionState,setdimensionState] = React.useState({companyDetail:[]})
    const[state,setState]= React.useState({shipment_list:[],isLoading:true})
    const [shipmentstate, setshipStatus] = React.useState({ shipment_status: null });
    const [shipSelect, setShipSelect] = React.useState({ shipment_id: "",cancel_reason:"" });
    const [modalState, setModalState] = React.useState({ show: false });
    const [modaldtdtcState, setModaldtdcState] = React.useState({ show: false });
    const[dtdc , setdtdc] = React.useState();
    const[loadingstate , setLoadingstate] = React.useState(false)
    const[summarystate , setSummarystate] = React.useState(false)
    const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
        const homeSection = document.querySelector('.home-section');
        if (homeSection) {
            homeSection.classList.toggle('sidebar-closed');
        }
    };


    const Toast = Swal.mixin({
      toast: true,
      position: 'bottom-end',
      showConfirmButton: false,
      timer: 5000
  })

    console.log("shipmentState",shipmentstate)
    React.useEffect(() => {
  
        shipment_list()
        dimension_detail()
    
      }, [])

    const shipment_list=(status)=>{
        let dataToSend = {  status:status
    };
   
      console.log("datatoSend",dataToSend)
      let url = exportValue.host + '/' + exportValue.version + '/' + exportValue.api +'/customer_orders';
     
     // console.log("headers => ", config.headers);
     
      
      axios.post(url, dataToSend, { headers: exportValue.headers })
          .then((res) => {
            console.log("responseJson => ", res);
            setState({shipment_list:res.data.output,isLoading:false})
         
          })
          .catch((error) => {
              //Hide Loader
            //   setLoadingstate({...loadingstate,loading:false})
              console.log(error);
          });    

    }

    const dimension_detail = () =>{   
      let full_api =   exportValue.apiUrl + '/user/get_company_info_api';
      // `https://backend.shiport.in/v.1.0.1/web/query/user/get_company_info_api`;
      let sendData = {};
    
      axios.post(full_api, sendData, {headers:exportValue.headers}).then(res => {
        setdimensionState({...dimensionState,companyDetail:res.data.companyDetail});
        console.log("rnmmmmm", res);
      }).catch((e) => {
        // toast.configure()
         //toast.error("Some thing went wrong")
        console.log("----error:   ", e);
      })
    }

    // const shipmentFilter = (status) => {
    //   console.log("action ", status);
    //   setshipStatus({ ...shipmentstate, shipment_status: status })
    //   shipment_list(status)
    // }

    // const cancelModal = (ship) =>{
    //   console.log("----ship:   ", ship.shipment_id);
    //   setShipSelect({cancel_reason:"",shipment_id:ship.shipment_id});
    //   setModalState({ show: true })
     
    // }

    

    const inputHandleChange = (e) => {
      const value = e.target.value;
      const text = e.target.name;
      setShipSelect({ ...shipSelect, [text]: value })
    }
    
  

   const csvinputEditHandleChange = (e) => {        
    if (e.target.type == "file") {            
        setUploadModalState({ ...uploadModalState, [e.target.name]: e.target.files });
    } else {
        setUploadModalState({ ...uploadModalState, [e.target.name]: e.target.value });
    }
  }
  const uploadOrdersFile= () => {
    
    // if(uploadModalState.customer_id!=undefined && uploadModalState.customer_id!=""){
    if (uploadModalState.excel_fle != undefined && uploadModalState.excel_fle != '') {
      setLoadingstate(true)
       // var patt1 = /\.([0-9a-z]+)(?:[\?#]|$)/i;
        let fileName = uploadModalState.excel_fle[0].name;
       // console.log("fileName =======>                 ",fileName);
       
       // console.log("file =======>                 ",fileName.match(/\.([0-9a-z]+)(?:[\?#]|$)/i)[0]);
       // return 
        if(fileName.match(/\.([0-9a-z]+)(?:[\?#]|$)/i)[0] == ".csv"){
          let url = exportValue.host + '/' + exportValue.version + '/' + exportValue.api +'/upload_bulk_orders';
     
            // let full_api = exportValue.apiUrl + '/shipment/upload_bulk_orders';
            // `https://backend.shiport.in/v.1.0.1/web/query/shipment/upload_bulk_orders`;
     let bodyFormData = new FormData()
    // console.log("bb", editState);
    
      bodyFormData.append("customer_id",  detail.admin_id)
    

    
    bodyFormData.append("excel_fle", uploadModalState.excel_fle[0]);
     
   // let bodyData = {country_id:country_id,csvFile:uploadModalState.csv_fle}
    console.log("bb", bodyFormData);
    axios.post(url, bodyFormData, {headers:exportValue.headers}).then((res) => {
        console.log("res ", res);

        // setUploadModalState({...uploadModalState, show: false });
      //  setEditState({ ...editState, state_name: "", state_id: "" })

       
        if (res.status == 200 && res.data.status == "success") {
          setLoadingstate(false)
          setSummarystate(true)
           setRecordid({record_id:res.data.record_id})
           // setTimeout(getStateList(0,true), 5000);
           const Toast = Swal.mixin({
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000
        })
            Toast.fire({
                background: "#206bc4",
                type: 'success',
                title: "Successfully Inserted",
                color: "white"
            });
            // shipment_list()
            // setTimeout(()=>{
            //   navigate(`/import_process/${product_id}/${carrier_id}/${source_city_id}`)
            // },1000)
            
        }
        
        else {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Something went wrong!',

            })
        }

        // navigate('/categories')
        // let newCategory = res.data.category;
        //setState(state.concat([newCategory]))
    }).catch((e) => {

        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong!',

        })
    });
}else {
  const Toast = Swal.mixin({
    toast: true,
    position: 'bottom-end',
    showConfirmButton: false,
    timer: 3000
})
    Toast.fire({
        background: "#206bc4",
        type: 'error',
        title: "Please choose CSV file!",
        color: "white"
    });
}
}else {
  const Toast = Swal.mixin({
    toast: true,
    position: 'bottom-end',
    showConfirmButton: false,
    timer: 3000
})
         Toast.fire({
                background: "#206bc4",
                type: 'error',
                title: "Please choose a file!",
                color: "white"
            });
}
  // }
  // else {
  //   const Toast = Swal.mixin({
  //     toast: true,
  //     position: 'bottom-end',
  //     showConfirmButton: false,
  //     timer: 3000
  // })
  //          Toast.fire({
  //                 background: "#206bc4",
  //                 type: 'error',
  //                 title: "Please select Customer First",
  //                 color: "white"
  //             });
  // }

}
const closeModal =()=>{
  setUploadModalState({...uploadModalState,show:false})
  shipment_list()
}

// const handleSelectChange = selectedOption => {
//    setSelectedOption1(selectedOption);
//    setUploadModalState({...uploadModalState , customer_id:selectedOption.value})
//   //  setAddressState({...addstate, pincode:selectedOption})
// };
const customers_all= ()=>{
  let url = exportValue.host + '/' + exportValue.version + '/' + exportValue.api + `/all_customers`;
  let sendData = {};
  console.log("bb", sendData);
  axios.post(url,sendData ,{headers:exportValue.headers}).then((res)=>{
      if(res.data.status=="success"){
          console.log("sasdfdsa")
          setCustomers(res.data.output)
          let data = res.data.output
          const customerOptions = data.map(item => ({
           value: item.customer_id, // Set the value property based on your data
           label: item.full_name // Set the label property based on your data
         }));
         setCustomerOption(customerOptions)
          // setaddressState(res.data.output)
      }

  }).catch(()=>{
      const Toast = Swal.mixin({
          toast: true,
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000
        })
        
        Toast.fire({
          background:"#206bc4",
          type: 'unsuccess',
          title: "Something Went Wrong",
          color:"white"
        });
 
     
  })
 }
 const openmodalupload=()=>{
  setUploadModalState({...uploadModalState,show:true})
  customers_all()
 }
 const next_step = (sub)=>{
  console.log("subv==== " , sub.cod_amount)
  console.log("payment_mode==== " , sub.payment_mode)
  console.log("volumetric_weight==== " , sub.volumetric_weight)
  // console.log("subv==== " , sub.cod_amount)

  if(sub.sender[0].name!=undefined && sub.sender[0].name!="" && sub.sender[0].address!=undefined && sub.sender[0].address!="" &&sub.sender[0].country!=undefined && sub.sender[0].country!="" && sub.sender[0].country_code!=undefined && sub.sender[0].country_code!="" && sub.sender[0].pincode!=undefined && sub.sender[0].pincode!="" && sub.sender[0].state!=undefined && sub.sender[0].state!="" && sub.sender[0].city!=undefined && sub.sender[0].city!="" && sub.address_id!=undefined && sub.address_id!="" && sub.sender[0].city_id!=undefined && sub.sender[0].city_id!="" && sub.sender[0].mobile!=undefined && sub.sender[0].mobile!="" && sub.sender[0].email!=undefined && sub.sender[0].email!="" && sub.receiver[0].name!=undefined && sub.receiver[0].name!="" && sub.receiver[0].email!=undefined && sub.receiver[0].email!="" && sub.receiver[0].mobile!=undefined && sub.receiver[0].mobile !="" && sub.receiver[0].address !=undefined && sub.receiver[0].address!="" && sub.receiver[0].country!=undefined && sub.receiver[0].country!="" && sub.receiver[0].country_code!=undefined && sub.receiver[0].country_code!="" && sub.receiver[0].pincode!=undefined && sub.receiver[0].pincode!="" && sub.receiver[0].city!=undefined && sub.receiver[0].city!="" && sub.receiver[0].state!=undefined && sub.receiver[0].state!="" && sub.return[0].name!=undefined && sub.return[0].name!="" && sub.return[0].email!=undefined && sub.return[0].email!="" && sub.return[0].mobile!=undefined && sub.return[0].mobile !="" && sub.return[0].address !=undefined && sub.return[0].address!="" && sub.return[0].country!=undefined && sub.return[0].country!="" && sub.return[0].country_code!=undefined && sub.return[0].country_code!="" && sub.return[0].pincode!=undefined && sub.return[0].pincode!="" && sub.return[0].city!=undefined && sub.return[0].city!="" && sub.return[0].state!=undefined && sub.return[0].state!=""  && sub.mode!=undefined && sub.mode !="" && sub.items.length >0 && sub.type!=undefined && sub.type!="" && sub.order_number!=undefined && sub.order_number!=""  && sub.total_weight!=undefined && sub.total_weight!="" && sub.height!=undefined && sub.height!="" && sub.width!=undefined && sub.width!="" && sub.length!=undefined && sub.length!="" && sub.cod_amount !=undefined  &&  sub.payment_mode!=undefined && sub.payment_mode!="" && sub.volumetric_weight!=undefined ){
   navigate({pathname:`/package_list`,
 search: `sender_name=${sub.sender[0].name}&sender_address=${sub.sender[0].address}&sender_country=${sub.sender[0].country}&sender_country_code=${sub.sender[0].country_code}&sender_postal_code=${sub.sender[0].pincode}&sender_state_name=${sub.sender[0].state}&sender_city=${sub.sender[0].city}&sender_address_id=${sub.address_id}&sender_city_id=${sub.sender[0].city_id}&sender_mobile=${sub.sender[0].mobile}&sender_email=${sub.sender[0].email}&receiver_name=${sub.receiver[0].name}&receiver_email=${sub.receiver[0].email}&receiver_mobile=${sub.receiver[0].mobile}&receiver_address=${sub.receiver[0].address}&receiver_country=${sub.receiver[0].country}&receiver_country_code=${sub.receiver[0].country_code}&receiver_postal_code=${sub.receiver[0].pincode}&receiver_city=${sub.receiver[0].city}&receiver_state_name=${sub.receiver[0].state}&return_name=${sub.return[0].name}&return_email=${sub.return[0].email}&return_mobile=${sub.return[0].mobile}&return_address=${sub.return[0].address}&return_country=${sub.return[0].country}&return_country_code=${sub.return[0].country_code}&return_postal_code=${sub.return[0].pincode}&return_city=${sub.return[0].city}&return_state_name=${sub.return[0].state}&mode=${sub.mode}${sub.items.map((i)=>(`&items=${i.item_value},${i.item_name},${i.item_quantity}`))}&shipment_type=${sub.type}&insurance=${sub.insurance_amount}&order_id=${sub.order_number}&order_date=${sub.order_date}&weight=${sub.total_weight}&height=${sub.height}&width=${sub.width}&length=${sub.length}&cod_amount=${sub.cod_amount}&payment_mode=${sub.payment_mode}&store_id=${sub.store_id!=undefined?sub.store_id:""}&channel_name=${sub.channel_name!=undefined?sub.channel_name:""}&volumetric_weight=${sub.volumetric_weight}&receiver_city_id=${sub.receiver[0].city_id}&receiver_state_id=${sub.receiver[0].state_id}&customer_id=${sub.customer_id}`
})
}
else{
const Toast = Swal.mixin({
  toast: true,
  position: 'bottom-end',
  showConfirmButton: false,
  timer: 3000
})       
Toast.fire({
background:"rgb(25, 135, 84)",
type: 'unsuccess',
title: "Please Fill All The Details.",
color:"white"
}); 
}
}
  return (

<div>
<Modal show={modalState.show} onHide={() => setModalState({ show: false })}>
<Modal.Header closeButton>
                    <Modal.Title>Do you really want to Cancel ?</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                <div className="row">
                      <div className="col-2 mb-3 mt-5" style={{marginLeft:"25px"}}>
                      <i class="fa fa-envelope " style={{fontSize:"20px",marginTop:"10px"}} aria-hidden="true"></i>
                      </div>
                        <div className="col-md-10 mb-3 mt-5 " style={{marginLeft:"-50px"}}>
                              <input className="form-control" id="first_name" type="text" placeholder="Enter Reason" name="cancel_reason" onChange={(e) => inputHandleChange(e)} required   style={{ background: "transparent", border: "none", borderBottom: "1px solid #000000",  outline:"none", boxShadow:"none"}}/>
                         </div>
                         
                         {/* <div className="col-2 mb-1 mt-3" style={{marginLeft:"25px"}}>
                         <i class="fa fa-lock " style={{fontSize:"20px",marginTop:"10px"}} aria-hidden="true"></i>
                      </div> */}
                         
                       <div>
                       
                    {/* <button className="btn mt-3" style={{color: "#fff", backgroundColor: "#D65142", display:"inline-block",textAlign:"center",verticalAlign:"middle",position:"relative",boxSizing:"border-box",marginLeft:"190px",padding: "0.84rem 2.14rem",
    fontSize: "18px",fontWeight:"bold"}} onClick={() =>
      cancelShipment()
                        }>Yes</button> */}
                    </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
               
                  <Button variant="secondary" onClick={() => setModalState({ show: false })}>
                        Close
                    </Button>
                              
                </Modal.Footer>
            </Modal>

          <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />  
           

{state.isLoading==true?
        <ReactLoading type="bubbles" color="#0d6efd" style={{ position: 'absolute', right: '45%', height: '20px', width: '10%' }} />:
        <section class="home-section">
           <Sub_header/>
      <section class="py-4">
           
      
 

    <div class="card mb-3">
      <div class="card-body">
        <header class="">
            <div class="row mb-4 mt-3">
                <div class="col col-md">
                    <div class="d-flex">
                        <div class="">
                            <h4><a href=""><i class="material-icons">chevron_left</i></a> My Orders</h4>
                        </div>
                        <div class="ps-2 pt-2"><h6 class="text-muted">({state.shipment_list.length} Shipments)</h6></div>
                    </div>
                    
                </div>
                <div class="col col-md-2 mb_display_none">
                    <div class="d-grid">
                        <a onClick={()=>navigate({
            pathname: '/ship_1',
            search: `value=0`,
          })} class="btn btn-primary"> Create Order</a>
                    </div>
                </div>
                <div class="col col-md-2 mb_display_none">
                    <div class="d-grid">
                        <a class="btn btn-primary" onClick={()=>openmodalupload()}>Import Bulk Orders</a>
                    </div>
                </div>
                <Modal show={uploadModalState.show} onHide={()=>setUploadModalState({...uploadModalState,show:false})}>
               
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <ModalTitle><h4 class="modal-title">Import Bulk Orders </h4></ModalTitle>
        
        <button type="button" class="btn-close" onClick={()=>closeModal()}></button>
      </div>
      <div class="modal-body">
        <div class="alert alert-success">
          <strong>Alert!</strong> 
          <ul>
            <li>This action can not be undone.</li>
            <li>Doing the corrupt or broken variable file can cause system malfunction.</li>
            <li>Download sample file and setup the file in correct format to import</li>
          </ul>
        </div>
        <div class="d-flex justify-content-between">
            <div class="">Download Sample File</div>
            <div class="ps-2 "><a href="https://cdn.shreebanshidharlogistics.com/sample-template/dispatcher-bulk-order-template.csv" target="_blank"  class="btn btn-outline-primary btn-sm">Downlaod Sample File</a></div>
        </div>
        <hr/>
        {/* <div className='mb-3 mt-3' >
        <label for="" class="form-label">Select Customer: <span class="text-danger">*</span></label>
            <section class="mb-3">
              <div>
              <Select
    
      placeholder="Select Customer"
      options={customeroption}
      value={selectedOption1}
      onChange={(e)=>handleSelectChange(e)}
      isClearable={true}
      name="customer"
    />
               
              </div>
              
            </section>
        </div> */}
        <div class="mb-3 mt-3">
          <label for="" class="form-label">File: <span class="text-danger">*</span></label>
          <input type="file" class="form-control" id="" placeholder="Enter Banner"  required="" name="excel_fle" onChange={(e) => csvinputEditHandleChange(e)} />
        </div>
      </div>
      <div class="modal-footer">
       {loadingstate==false && summarystate==false? <a class="btn btn-primary btn-block" onClick={() =>uploadOrdersFile()} >Submit</a>:loadingstate==true && summarystate==false?<ReactLoading type={"spin"} color={"#dc291e"}  height={40} width={40} />:summarystate==true?<a class="btn btn-primary btn-block" href={`/summary/${recordid.record_id}`} >View Summary</a>:""}
        {/* <button type="button" class="btn btn-main btn-block" onClick={()=>closeModal()}>Close</button> */}
      </div>
    </div>
  </div>

</Modal>
            </div>
            
        </header>
      </div>
    </div>

    

    <div class="card ">
      <div class="card-body border-0 shadow table-wrapper table-responsive mt-3">
      

        <table class="table  table-hover table-bordered shipm_tablew">
            <thead>
              <tr class="">
                <th>Customer Name</th>
                <th>Order Number</th>
                <th>Origin</th>
                <th>Destination</th>
                <th>Sender</th>
                <th>Receiver</th>
                <th>Name of product</th>
                <th></th>
                
              </tr>
            </thead>
            <tbody>
                {state.shipment_list.map((sub)=>(
                <tr class="">
                  <td>{sub.full_name}</td>
                    <td>
                        
                        <a >#{sub.order_number}</a><br/>
                        <small class="text-muted">
                            {/* <Moment format="DD MM YYYY"> */}
                        {(sub.order_date)}
            {/* </Moment>   */}
            </small>
                    </td>
                    {sub.sender.map((item)=>(
                    <td>

                        {item.pincode} - {item.city}<br/>
                        <small class="text-muted"> {item.country}</small>
                    </td>
                    ))}
                    {sub.receiver.map((i)=>(
                    <td>
                        {i.pincode} - {i.city}<br/>
                        <small class="text-muted">{i.country}</small>
                    </td>
                    ))}
                    {sub.sender.map((item)=>(
                    <td>
                        {item.name}
                    </td>
                    ))}
                     {sub.receiver.map((i)=>( 
                    <td>
                        {i.name}
                    </td>
                    ))}
                   
                    <td>
                    {sub.items.map((sub,index)=>(
                        <h6> {sub.item_name}
                        <small class="text-muted"></small> 
                        </h6>))}
                        <small class="text-muted">Total Item - {sub.items.length}</small><br/>
                        <small class="text-muted">Total Weight - {sub.total_weight} ({dimensionState.companyDetail.map((subscriber)=>( 
                                  <>{subscriber.set_weight}</>
                                 ))})</small>
                    </td>
                    
                 <td><button className='btn btn-primary' onClick={()=> next_step(sub)}>Book Now</button></td>
                </tr>
                ))}
                
            </tbody>
          </table>
      </div>
    </div>

         
</section>
</section>
}
{/* <Footer/> */}
</div>
  )
}

export default My_orders
